module.exports = __webpack_public_path__ + "c0fab4f8ac7a0fabcfc9be233f98a779.png";